import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';
import { ALERT_TAB_MENU } from '../../utils/menu';
import { AlertDataSection } from '../../components/common/common.alert.data.section';
import {
  fetchReceiveNotificationCompany,
  fetchReceiveNotificationDriver,
  fetchSendNotificationCompany,
  fetchSendNotificationDriver,
} from '../../api/alert';
import { useRecoilValue } from 'recoil';
import { authState } from '../../atoms/authState';

interface FetchSendNotificationResponse {
  orderId: number;
  obtainId: number;
  vehicle?: string;
  name: string;
  content: string;
  createdAt: string;
}

const CommonAlert = () => {
  const auth = useRecoilValue(authState);

  const [currentTab, setCurrentTab] = useState(0);
  const [receiveList, setReceiveList] = useState<
    FetchSendNotificationResponse[]
  >([]);
  const [sendList, setSendList] = useState<FetchSendNotificationResponse[]>([]);
  const location = useLocation();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = parseInt(queryParams.get('tab') ?? '0', 10);
    setCurrentTab(tab);
  }, [location]);

  const selectMenuHandler = (index: number) => {
    setCurrentTab(index);
  };

  useEffect(() => {
    const getReceiveDriverData = async () => {
      if (auth.userType === 'driver') {
        if (currentTab === 0) {
          const response = await fetchReceiveNotificationDriver({});
          console.log(response);
          setReceiveList(response);
        } else {
          const response = await fetchSendNotificationDriver({});
          console.log(response);
          setSendList(response);
        }
      } else if (auth.userType === 'company') {
        if (currentTab === 0) {
          const response = await fetchReceiveNotificationCompany({});
          setReceiveList(response);
        } else {
          const response = await fetchSendNotificationCompany({});
          setSendList(response);
        }
      }
    };
    getReceiveDriverData();
  }, [currentTab, auth.userType]);

  return (
    <Container>
      <TabBox>
        <TabMenu>
          {ALERT_TAB_MENU.map((item, index) => (
            <li
              key={index}
              onClick={() => selectMenuHandler(index)}
              className={index === currentTab ? 'active' : ''}
            >
              {item}
            </li>
          ))}
        </TabMenu>
        <TabContents>
          {currentTab === 0 ? (
            receiveList.length === 0 ? (
              <div className="no-data">받은 알림이 없습니다.</div>
            ) : (
              <AlertDataSection datas={receiveList} />
            )
          ) : currentTab === 1 ? (
            sendList.length === 0 ? (
              <div className="no-data">보낸 알림이 없습니다.</div>
            ) : (
              <AlertDataSection datas={sendList} />
            )
          ) : null}
        </TabContents>
      </TabBox>
    </Container>
  );
};

export default CommonAlert;

// style
const Container = styled.div`
  padding: 1.2rem 1.5rem;
  .no-data {
    margin-top: 2rem;
    font-size: 1.6rem;
    text-align: center;
  }
`;

const TabBox = styled.div``;

const TabMenu = styled.ul`
  border-bottom: 1px solid ${(props) => props.theme.gray300};
  margin-top: -1.2rem;
  display: flex;
  li {
    flex-basis: 12.6rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1.4rem;
    font-size: 1.6rem;
    font-weight: 500;
    color: ${(props) => props.theme.textAAAColor};
    &.active {
      color: black;
      position: relative;
      &::after {
        content: '';
        position: absolute;
        left: 0;
        bottom: -2px;
        height: 2px;
        width: 100%;
        background-color: black;
      }
    }
  }
`;

const TabContents = styled.div`
  height: calc(100vh - 12rem);
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;
